import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { t } from 'i18next';

import { ObjectValues } from 'helpers/types';

export const QUARTER_NAMES = {
  Q1: 'q1',
  Q2: 'q2',
  Q3: 'q3',
  Q4: 'q4',
} as const;

export interface IQuarter {
  [QUARTER_NAMES.Q1]: string | number;
  [QUARTER_NAMES.Q2]: string | number;
  [QUARTER_NAMES.Q3]: string | number;
  [QUARTER_NAMES.Q4]: string | number;
}

export const useGetQuarterValues = () => {
  const { t, i18n } = useTranslation();

  return useMemo(() => {
    const quarterValues = {
      [QUARTER_NAMES.Q1]: `${t('timePeriods.quarter')} 1`,
      [QUARTER_NAMES.Q2]: `${t('timePeriods.quarter')} 2`,
      [QUARTER_NAMES.Q3]: `${t('timePeriods.quarter')} 3`,
      [QUARTER_NAMES.Q4]: `${t('timePeriods.quarter')} 4`,
    };
    return quarterValues;
  }, [t, i18n]);
};

export const quarterValues = {
  [QUARTER_NAMES.Q1]: `${t('timePeriods.quarter')} 1`,
  [QUARTER_NAMES.Q2]: `${t('timePeriods.quarter')} 2`,
  [QUARTER_NAMES.Q3]: `${t('timePeriods.quarter')} 3`,
  [QUARTER_NAMES.Q4]: `${t('timePeriods.quarter')} 4`,
};
export const quarterRowInitialValues = {
  [QUARTER_NAMES.Q1]: '',
  [QUARTER_NAMES.Q2]: '',
  [QUARTER_NAMES.Q3]: '',
  [QUARTER_NAMES.Q4]: '',
};

export const PERIOD_NAMES = {
  QUARTER_VALUES: 'quarterValues',
  MONTH_VALUES: 'monthValues',
  HALF_VALUES: 'halfValues',
  YEAR_VALUES: 'yearsValues',
} as const;

export type IPeriodNames = ObjectValues<typeof PERIOD_NAMES>;

export const MONTH_NAMES = {
  M1: 'm1',
  M2: 'm2',
  M3: 'm3',
  M4: 'm4',
  M5: 'm5',
  M6: 'm6',
  M7: 'm7',
  M8: 'm8',
  M9: 'm9',
  M10: 'm10',
  M11: 'm11',
  M12: 'm12',
} as const;

export interface IMonth {
  [MONTH_NAMES.M1]: string | number;
  [MONTH_NAMES.M2]: string | number;
  [MONTH_NAMES.M3]: string | number;
  [MONTH_NAMES.M4]: string | number;
  [MONTH_NAMES.M5]: string | number;
  [MONTH_NAMES.M6]: string | number;
  [MONTH_NAMES.M7]: string | number;
  [MONTH_NAMES.M8]: string | number;
  [MONTH_NAMES.M9]: string | number;
  [MONTH_NAMES.M10]: string | number;
  [MONTH_NAMES.M11]: string | number;
  [MONTH_NAMES.M12]: string | number;
}

export const useGetMonthValues = () => {
  const { t, i18n } = useTranslation();

  return useMemo(() => {
    const monthValues = {
      [MONTH_NAMES.M1]: `${t('timePeriods.mth')} 1`,
      [MONTH_NAMES.M2]: `${t('timePeriods.mth')} 2`,
      [MONTH_NAMES.M3]: `${t('timePeriods.mth')} 3`,
      [MONTH_NAMES.M4]: `${t('timePeriods.mth')} 4`,
      [MONTH_NAMES.M5]: `${t('timePeriods.mth')} 5`,
      [MONTH_NAMES.M6]: `${t('timePeriods.mth')} 6`,
      [MONTH_NAMES.M7]: `${t('timePeriods.mth')} 7`,
      [MONTH_NAMES.M8]: `${t('timePeriods.mth')} 8`,
      [MONTH_NAMES.M9]: `${t('timePeriods.mth')} 9`,
      [MONTH_NAMES.M10]: `${t('timePeriods.mth')} 10`,
      [MONTH_NAMES.M11]: `${t('timePeriods.mth')} 11`,
      [MONTH_NAMES.M12]: `${t('timePeriods.mth')} 12`,
    };

    return monthValues;
  }, [t, i18n]);
};

export const monthValues = {
  [MONTH_NAMES.M1]: `${t('timePeriods.mth')} 1`,
  [MONTH_NAMES.M2]: `${t('timePeriods.mth')} 2`,
  [MONTH_NAMES.M3]: `${t('timePeriods.mth')} 3`,
  [MONTH_NAMES.M4]: `${t('timePeriods.mth')} 4`,
  [MONTH_NAMES.M5]: `${t('timePeriods.mth')} 5`,
  [MONTH_NAMES.M6]: `${t('timePeriods.mth')} 6`,
  [MONTH_NAMES.M7]: `${t('timePeriods.mth')} 7`,
  [MONTH_NAMES.M8]: `${t('timePeriods.mth')} 8`,
  [MONTH_NAMES.M9]: `${t('timePeriods.mth')} 9`,
  [MONTH_NAMES.M10]: `${t('timePeriods.mth')} 10`,
  [MONTH_NAMES.M11]: `${t('timePeriods.mth')} 11`,
  [MONTH_NAMES.M12]: `${t('timePeriods.mth')} 12`,
};

export const monthRowInitialValues = {
  [MONTH_NAMES.M1]: '',
  [MONTH_NAMES.M2]: '',
  [MONTH_NAMES.M3]: '',
  [MONTH_NAMES.M4]: '',
  [MONTH_NAMES.M5]: '',
  [MONTH_NAMES.M6]: '',
  [MONTH_NAMES.M7]: '',
  [MONTH_NAMES.M8]: '',
  [MONTH_NAMES.M9]: '',
  [MONTH_NAMES.M10]: '',
  [MONTH_NAMES.M11]: '',
  [MONTH_NAMES.M12]: '',
};

export const HALF_NAMES = {
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4',
  H5: 'h5',
  H6: 'h6',
} as const;

export interface IHalf {
  [HALF_NAMES.H1]: string | number;
  [HALF_NAMES.H2]: string | number;
  [HALF_NAMES.H3]: string | number;
  [HALF_NAMES.H4]: string | number;
  [HALF_NAMES.H5]: string | number;
  [HALF_NAMES.H6]: string | number;
}

export const useGetHalfValues = () => {
  const { t, i18n } = useTranslation();

  return useMemo(() => {
    const halfValues = {
      [HALF_NAMES.H1]: `${t('timePeriods.halfsShort')}1(${t('timePeriods.yearShort')}1)`,
      [HALF_NAMES.H2]: `${t('timePeriods.halfsShort')}2(${t('timePeriods.yearShort')}1)`,
      [HALF_NAMES.H3]: `${t('timePeriods.halfsShort')}1(${t('timePeriods.yearShort')}2)`,
      [HALF_NAMES.H4]: `${t('timePeriods.halfsShort')}2(${t('timePeriods.yearShort')}2)`,
      [HALF_NAMES.H5]: `${t('timePeriods.halfsShort')}1(${t('timePeriods.yearShort')}3)`,
      [HALF_NAMES.H6]: `${t('timePeriods.halfsShort')}2(${t('timePeriods.yearShort')}3)`,
    };

    return halfValues;
  }, [t, i18n]);
};

export const halfValues = {
  [HALF_NAMES.H1]: `${t('timePeriods.halfsShort')}1(${t('timePeriods.yearShort')}1)`,
  [HALF_NAMES.H2]: `${t('timePeriods.halfsShort')}2(${t('timePeriods.yearShort')}1)`,
  [HALF_NAMES.H3]: `${t('timePeriods.halfsShort')}1(${t('timePeriods.yearShort')}2)`,
  [HALF_NAMES.H4]: `${t('timePeriods.halfsShort')}2(${t('timePeriods.yearShort')}2)`,
  [HALF_NAMES.H5]: `${t('timePeriods.halfsShort')}1(${t('timePeriods.yearShort')}3)`,
  [HALF_NAMES.H6]: `${t('timePeriods.halfsShort')}2(${t('timePeriods.yearShort')}3)`,
};

export const halfRowInitialValues = {
  [HALF_NAMES.H1]: '',
  [HALF_NAMES.H2]: '',
  [HALF_NAMES.H3]: '',
  [HALF_NAMES.H4]: '',
  [HALF_NAMES.H5]: '',
  [HALF_NAMES.H6]: '',
};

export const YEARS_NAMES = {
  Y1: 'y1',
  Y2: 'y2',
  Y3: 'y3',
  Y4: 'y4',
  Y5: 'y5',
} as const;

export interface IYear {
  [YEARS_NAMES.Y1]: string | number;
  [YEARS_NAMES.Y2]: string | number;
  [YEARS_NAMES.Y3]: string | number;
  [YEARS_NAMES.Y4]: string | number;
  [YEARS_NAMES.Y5]: string | number;
}

export const useGetYearValues = () => {
  const { t, i18n } = useTranslation();

  return useMemo(() => {
    const yearValues = {
      [YEARS_NAMES.Y1]: `${t('timePeriods.yearUp')} 1`,
      [YEARS_NAMES.Y2]: `${t('timePeriods.yearUp')} 2`,
      [YEARS_NAMES.Y3]: `${t('timePeriods.yearUp')} 3`,
      [YEARS_NAMES.Y4]: `${t('timePeriods.yearUp')} 4`,
      [YEARS_NAMES.Y5]: `${t('timePeriods.yearUp')} 5`,
    };

    return yearValues;
  }, [t, i18n]);
};

export const yearValues = {
  [YEARS_NAMES.Y1]: `${t('timePeriods.yearUp')} 1`,
  [YEARS_NAMES.Y2]: `${t('timePeriods.yearUp')} 2`,
  [YEARS_NAMES.Y3]: `${t('timePeriods.yearUp')} 3`,
  [YEARS_NAMES.Y4]: `${t('timePeriods.yearUp')} 4`,
  [YEARS_NAMES.Y5]: `${t('timePeriods.yearUp')} 5`,
};

export const yearRowInitialValues = {
  [YEARS_NAMES.Y1]: '',
  [YEARS_NAMES.Y2]: '',
  [YEARS_NAMES.Y3]: '',
  [YEARS_NAMES.Y4]: '',
  [YEARS_NAMES.Y5]: '',
};

export type IPeriodValue = IQuarter | IMonth | IHalf | IYear;
export type IPeriodValues = IPeriodValue[];

export const periodsConfig = [
  { period: PERIOD_NAMES.QUARTER_VALUES, columns: Object.values(QUARTER_NAMES) },
  { period: PERIOD_NAMES.MONTH_VALUES, columns: Object.values(MONTH_NAMES) },
  { period: PERIOD_NAMES.HALF_VALUES, columns: Object.values(HALF_NAMES) },
  { period: PERIOD_NAMES.YEAR_VALUES, columns: Object.values(YEARS_NAMES) },
];

export const useGetPeriodOptions = () => {
  const { t, i18n } = useTranslation();
  return useMemo(() => {
    const periodOptions = [
      { label: `1 ${t('timePeriods.year')} (${t('timePeriods.quarterShort')})`, value: PERIOD_NAMES.QUARTER_VALUES },
      { label: `1 ${t('timePeriods.year')} (${t('timePeriods.monthShort')})`, value: PERIOD_NAMES.MONTH_VALUES },
      { label: `3 ${t('timePeriods.years')}`, value: PERIOD_NAMES.HALF_VALUES },
      { label: `5 ${t('timePeriods.5years')}`, value: PERIOD_NAMES.YEAR_VALUES },
    ];
    return periodOptions;
  }, [t, i18n]);
};

export interface IPeriodsTableRow extends Record<IPeriodNames, Record<string, string | number>> {}
export type IPeriodsTableRows = {
  [key in IPeriodNames]: IPeriodValue;
};

export const initialPeriodsTableRow: IPeriodsTableRow = {
  [PERIOD_NAMES.QUARTER_VALUES]: quarterRowInitialValues,
  [PERIOD_NAMES.MONTH_VALUES]: monthRowInitialValues,
  [PERIOD_NAMES.HALF_VALUES]: halfRowInitialValues,
  [PERIOD_NAMES.YEAR_VALUES]: yearRowInitialValues,
};

export const useGetInitialPeriodsTableHeadingRow = () => {
  const quarterValues = useGetQuarterValues();
  const monthValues = useGetMonthValues();
  const halfValues = useGetHalfValues();
  const yearValues = useGetYearValues();

  return useMemo(
    () => ({
      [PERIOD_NAMES.QUARTER_VALUES]: { ...quarterValues },
      [PERIOD_NAMES.MONTH_VALUES]: { ...monthValues },
      [PERIOD_NAMES.HALF_VALUES]: { ...halfValues },
      [PERIOD_NAMES.YEAR_VALUES]: { ...yearValues },
    }),
    [quarterValues, monthValues, halfValues, yearValues],
  );
};

export const initialPeriodsTableHeadingRow = {
  [PERIOD_NAMES.QUARTER_VALUES]: quarterValues,
  [PERIOD_NAMES.MONTH_VALUES]: monthValues,
  [PERIOD_NAMES.HALF_VALUES]: halfValues,
  [PERIOD_NAMES.YEAR_VALUES]: yearValues,
};
